export { Home as default } from '../layouts/Home/Home';
